(ns kyber.db.analytics
  (:require [clojure.spec.alpha :as s]))

(def initial-state {:application-context-ids []
                    :application-contexts {}
                    :event-contexts {}
                    :queue []
                    :stale-event-contexts #{}
                    :in-flight {}})

(s/def :component/context map?)
(s/def :component/tag simple-keyword?)
(s/def :component/id simple-keyword?)
(s/def :component/version number?)
(s/def :component/variant simple-keyword?)
(s/def ::component (s/keys :req-un [:component/context
                                    :component/tag
                                    :component/id
                                    :component/version
                                    :component/variant]))

(s/def ::event-name string?)
(s/def ::event-namespace string?)
(s/def ::event-version number?)
(s/def ::acid simple-keyword?)
(s/def ::ecid (s/nilable simple-keyword?))
(s/def ::datapoint (s/keys :req-un [::event-name
                                    ::event-namespace
                                    ::event-version
                                    ::acid]
                           :opt-un [::ecid
                                    ::component]))

(s/def ::queue (s/coll-of ::datapoint))

(s/def ::schema-version number?)
(s/def ::host string?)
(s/def ::path string?)
(s/def ::route-query (s/nilable map?))
(s/def ::route-params (s/nilable map?))
(s/def ::session-uuid string?)

(s/def ::url (s/keys :req-un [::host
                              ::path
                              ::route-query
                              ::route-params]))

(s/def ::application-context-ids (s/coll-of simple-keyword?))
(s/def ::application-context (s/keys :req-un [::schema-version
                                              ::url
                                              ::session-uuid]))
(s/def ::application-contexts (s/map-of simple-keyword? ::application-context))

(s/def ::event-context map?)
(s/def ::event-contexts (s/map-of simple-keyword? ::event-context))

(s/def ::stale-event-contexts (s/coll-of simple-keyword?))

;; Shorthand to save over the wire
(s/def ::q ::queue)
(s/def ::ectx ::event-contexts)
(s/def ::actx ::application-contexts)
(s/def ::in-flight (s/map-of qualified-keyword?
                             (s/keys :req-un [::q
                                              ::ectx
                                              ::actx])))

(s/def :kyber.db/analytics (s/keys :req-un [::application-context-ids
                                            ::application-contexts
                                            ::event-contexts
                                            ::stale-event-contexts
                                            ::in-flight
                                            ::queue]))
